module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/btn-effect/btn-effect.component.scss
// module id = ./src/app/features/buttons/btn-effect/btn-effect.component.scss
// module chunks = main